
























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import iwParkingSpaceCountOutdoor from "./ParkingSpaceCountOutdoor.vue";
import iwParkingSpaceCountIndoor from "./ParkingSpaceCountIndoor.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputCheckbox: iwInputCheckbox,
        iwParkingSpaceCountOutdoor: iwParkingSpaceCountOutdoor,
        iwParkingSpaceCountIndoor: iwParkingSpaceCountIndoor,
    },
    data: function() {
        return {
            pathInStoreIndoor: "property.parking.parkingSpaceCount.indoor",
            pathInStoreOutdoor: "property.parking.parkingSpaceCount.outdoor",
            pathInStoreUI: "property.hasParkingSpace",
        };
    },
    computed: {
        parkingSpaceCountOutdoor: function():  number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreOutdoor);
        },
        parkingSpaceCountIndoor: function():  number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreIndoor);
        },
        parkingSpaceCountOutdoorInput: function(): Vue | void {
            const accordionComponent = this.$refs.parkingSpaceCountOutdoor as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.parkingSpaceCountOutdoorInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        },
        parkingSpaceCountIndoorInput: function(): Vue | void {
            const accordionComponent = this.$refs.parkingSpaceCountIndoor as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.parkingSpaceCountIndoorInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        },

        hasParkingSpace: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
            },

            set: function(value: boolean) {
                this.$store.commit("FormModule/addValueUI", {
                    path: this.pathInStoreUI,
                    value: value,
                });

                if (value) {
                    this.$store.dispatch("FormModule/addValue", {
                        "path": this.pathInStoreIndoor,
                        "value": 1,
                    });

                    if(this.parkingSpaceCountIndoorInput) {
                        this.parkingSpaceCountIndoorInput.$data.internalValue = 1;
                    }

                    this.$store.dispatch("FormModule/addValue", {
                        "path": this.pathInStoreOutdoor,
                        "value": 1,
                    });

                    if(this.parkingSpaceCountOutdoorInput) {
                        this.parkingSpaceCountOutdoorInput.$data.internalValue = 1;
                    }
                }
                else {
                    this.$store.commit("FormModule/deleteValue", "property.parking");
                }
            },
        },
    },

    mounted: function() {
        const initialCheckboxState = (
            this.parkingSpaceCountOutdoor != null
            && this.parkingSpaceCountOutdoor != 0
        ) || (
            this.parkingSpaceCountIndoor != null
            && this.parkingSpaceCountIndoor != 0
        );

        this.$store.commit("FormModule/addValueUI", {
            "path": this.pathInStoreUI,
            "value": initialCheckboxState,
        });
    },

    methods: {
        updateValueOutdoor: function(parkingSpaceCountOutdoor: number): void {
            if (parkingSpaceCountOutdoor === 0 && this.parkingSpaceCountOutdoor != null) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreOutdoor, "value": 0});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreOutdoor, "value": parkingSpaceCountOutdoor});
            }
        },
        updateValueIndoor: function(parkingSpaceCountIndoor: number): void {
            if (parkingSpaceCountIndoor === 0 && this.parkingSpaceCountIndoor != null) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreIndoor, "value": 0});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreIndoor, "value": parkingSpaceCountIndoor});
            }
        },
    },
});

